export const CUSTOMER_SERVICE_EMAIL = 'support@immowelt.de';
export const CUSTOMER_SERVICE_PHONE = '+49 911 52025-0';
